import clsx from "clsx";

interface IconProps {
	className?: string
	theme?: 'light' | 'dark'
}

export const ClipboardIcon: React.FC<IconProps> = ({ className, theme= 'dark' }) => {
	return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 14 14"
      className={clsx(className, 'w-[1.2rem] h-[1.2rem]')}
    >
      <path
        stroke={theme === 'light' ? '#FF77A8' : '#131313'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.2"
        d="M4.703 9.254l4.5-4.5m-3-2.25L6.55 2.1a3.75 3.75 0 015.304 5.305l-.4.348m-3.751 3.75l-.298.4a3.801 3.801 0 01-5.346 0 3.729 3.729 0 01-.819-4.088c.19-.455.469-.868.82-1.215l.392-.347"
      ></path>
    </svg>
  );
}